import {
  KIOSK_RELEASE_STEP_NAME,
  KIOSK_RELEASE_TIMEOUT_MS,
} from '@mxa-argos/modules/forja/constants/forja.constants';
import type { ForjaStep } from '@mxa-argos/modules/forja/interfaces/forja-step.interface';
import { disableKioskMode } from '@mxa-argos/modules/forja/services/forja-ops.service';

export function kioskReleaseStep(): ForjaStep {
  return {
    name: KIOSK_RELEASE_STEP_NAME,
    verify: async (device) => !(await device.isKioskEngaged()),
    apply: async (device) => {
      await disableKioskMode(device.imei);
    },
    verifyTimeoutMs: KIOSK_RELEASE_TIMEOUT_MS,
    maxAttempts: 1,
  };
}
